import React from "react";
import { KeyRound, Search, ShoppingCart } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: KeyRound,
    title: "Saisis ta plaque",
    desc: "Format AA-123-AA. Notre moteur identifie ton véhicule en 1,2 seconde.",
  },
  {
    n: "02",
    icon: Search,
    title: "Choisis la pièce",
    desc: "Recherche libre, référence OEM, ou catégorie (freinage, filtration, moteur...).",
  },
  {
    n: "03",
    icon: ShoppingCart,
    title: "Compare & commande",
    desc: "13 fournisseurs comparés sur prix, délai, stock. Un clic, tu es chez eux.",
  },
];

export const HowItWorks = () => (
  <section
    id="how"
    data-testid="how-it-works-section"
    className="mx-auto max-w-7xl px-4 py-16 sm:px-8"
  >
    <div className="mb-10">
      <span className="font-mono text-xs uppercase tracking-widest text-cyan-400">
        Comment ça marche
      </span>
      <h2 className="mt-2 font-heading text-3xl font-extrabold text-slate-50 sm:text-4xl">
        3 étapes, zéro erreur
      </h2>
    </div>

    <div className="grid gap-6 md:grid-cols-3">
      {STEPS.map(({ n, icon: Icon, title, desc }, i) => (
        <div
          key={n}
          data-testid={`how-step-${i + 1}`}
          className="surface-card surface-card-hover relative overflow-hidden rounded-2xl p-6"
        >
          <div className="absolute -right-4 -top-4 font-heading text-7xl font-black text-slate-800/70">
            {n}
          </div>
          <div className="relative">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500/10 ring-1 ring-amber-500/30">
              <Icon className="h-5 w-5 text-amber-300" />
            </div>
            <h3 className="font-heading text-xl font-bold text-slate-50">{title}</h3>
            <p className="mt-2 text-sm text-slate-400">{desc}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
